<template lang="pug">
    div
        Card.asset-card
            p(slot="title")
                Icon(type="md-basket")
                |
                | Assets
            // Button(slot="extra" type="primary" :to="domainCreateUri" icon="md-create" size="small") Add Site
            Row
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="domains"
                        :description="$t('dashboard.assetDomainCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="FQDNConfigs"
                        :description="$t('dashboard.assetFqdnConfigCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="fqdns"
                        :description="$t('dashboard.assetFqdnCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="fqdnWildcard"
                        :description="$t('dashboard.assetFqdnWildcardCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="appProfiles"
                        :description="$t('dashboard.assetAppProfileCount')"
                        :groupNames="[queryGroupName]"
                    )

                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="wafRules"
                        :description="$t('dashboard.assetWafRuleCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="owaspRules"
                        :description="$t('dashboard.assetOwaspRuleCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="htmlPages"
                        :description="$t('dashboard.assetHtmlPageCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="originPolicies"
                        :description="$t('dashboard.assetOriginPolicyCount')"
                        :groupNames="[queryGroupName]"
                    )

                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="alertRules"
                        :description="$t('dashboard.assetAlertRuleCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12")
                    AssetSingleNum.singleNumCardMd(
                        category="notificationChannels"
                        :description="$t('dashboard.assetNotificationChannelCount')"
                        :groupNames="[queryGroupName]"
                    )

                Col(:lg="cardColSpan.lg" :md="12" v-if="isAdmin")
                    AssetSingleNum.singleNumCardMd(
                        category="recordLineGroups"
                        :description="$t('dashboard.assetRecordLineGroupCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12" v-if="isAdmin")
                    AssetSingleNum.singleNumCardMd(
                        category="servicegroups"
                        :description="$t('dashboard.assetServiceGroupCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12" v-if="isAdmin")
                    AssetSingleNum.singleNumCardMd(
                        category="certs"
                        :description="$t('dashboard.assetCertCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12" v-if="isAdmin")
                    AssetSingleNum.singleNumCardMd(
                        category="slbs"
                        :description="$t('dashboard.assetSlbCount')"
                        :groupNames="[queryGroupName]"
                    )
                Col(:lg="cardColSpan.lg" :md="12" v-if="isAdmin")
                    AssetSingleNum.singleNumCardMd(
                        category="edges"
                        :description="$t('dashboard.assetEdgeCount')"
                        :groupNames="[queryGroupName]"
                    )
                //- Col(:lg="cardColSpan.lg" :md="12")
                //-     AssetSingleNum.singleNumCardMd(
                //-         category="scroll"
                //-         :description="'scroll管理'"
                //-         :groupNames="[queryGroupName]"
                //-     )
</template>
<script>
import AssetSingleNum from "@/components/dashboard/asset/AssetSingleNum";

export default {
    name: "AssetCard",
    props: ["groupNames"],
    components: {
        AssetSingleNum,
    },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            cardColSpan: {
                lg: 6,
            },
        };
    },
    methods: {},
    mounted() {},
    computed: {
        domainCreateUri() {
            return this.$store.state.userData.privilege == "admin"
                ? "/admin/domainsetting?create=true"
                : "/domainsetting?create=true";
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        queryGroupName() {
            return this.$store.state.queryGroupName == "all" ? "*" : this.$store.state.queryGroupName;
        },
    },
};
</script>

<style scoped>
.singleNumCardMd {
    text-align: center;
    /* height: 96px; */
    margin: 10px 10px 0px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/AssetCard.vue